if (!customElements.get('subscription-plan-demo')) {
  customElements.define(
    'subscription-plan-demo',
    class SubscriptionPlanDemo extends HTMLElement {
      currentSectionId = null;

      get sectionId() {
        return this.getAttribute('data-section-id');
      }

      get sellingPlanInputs() {
        return this.querySelectorAll(`[data-selling-plan-input]`);
      }

      get productElement() {
        return this.closest('product-info');
      }

      get productForm() {
        this.currentSectionId = this.sectionId === this.productElement.dataset.section ? this.sectionId : this.productElement.dataset.section;
        return this.productElement.querySelector(`product-form[data-section-id="${this.currentSectionId}"]`);
      }

      get productPlanInput() {
        return this.productForm?.querySelector('input[name="selling_plan"]');
      }

      get subscriptionPlanInput() {
        return this.querySelector('input[type="radio"].form__input-plan');
      }

      get subscriptionPlanBenifits() {
        return this.querySelector('.selling-plan__included-benefits');
      }

      constructor() {
        super();
        this.clickEvent = this.handleClickEvent.bind(this);
        this.inputKeyUpEvent = this.handleInputKeyUpEvent.bind(this);
        this.inputTouchEndEvent = this.handleInputTouchEndEvent.bind(this);
        this.inputChangeEvent = this.handleInputChangeEvent.bind(this);
      }

      connectedCallback() {
        this.updatePlanInput();
        this.addEventListener('click', this.clickEvent);
        this.addEventListener('keyup', this.inputKeyUpEvent);
        this.addEventListener('touchend', this.inputTouchEndEvent);
        this.addEventListener('change', this.inputChangeEvent);

        if (Array.from(this.sellingPlanInputs).filter(input => input.checked)[0].value !== '')
          this.productElement.dataset.purchaseOption = 'Subscribe';

        console.log(this);
        console.log(this.productElement);
        console.log(Array.from(this.sellingPlanInputs).filter(input => input.checked)[0].value !== '');
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.clickEvent);
        this.removeEventListener('keyup', this.inputKeyUpEvent);
        this.removeEventListener('touchend', this.inputTouchEndEvent);
        this.removeEventListener('change', this.inputChangeEvent);
      }

      preventDefaults(event) {
        if (!this.sellingPlanInputs?.length) {
          event.preventDefault();
          return;
        }
      }

      handleClickEvent(event) {
        if (!this.subscriptionPlanBenifits.querySelector('.card_remove').contains(event.target)) return;
        this.subscriptionPlanBenifits.classList.add('hidden');
        this.removeSellingProps();
      }

      handleInputKeyUpEvent(event) {
        this.preventDefaults(event);
      }

      handleInputTouchEndEvent(event) {
        this.preventDefaults(event);
      }

      handleInputChangeEvent(event) {
        if (!this.productElement.contains(event.target)) return;
        this.updatePlanInput();
        this.subscriptionPlanInput.contains(event.target) ? this.addSellingProps() : this.removeSellingProps();
      }

      addSellingProps() {
        if (this.subscriptionPlanBenifits.classList.contains('hidden')) return;
        if (this.querySelector('template').content.firstElementChild)
          this.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      }

      removeSellingProps() {
        this.querySelector('input[type="hidden"]')?.remove();
      }

      updatePlanInput() {
        if (!this.sellingPlanInputs?.length) return;
        this.sellingPlanInputs.forEach((input) => {
          if (!input.checked) return;
          if (input.value) {
            this.productPlanInput?.hasAttribute('disabled') && this.productPlanInput?.removeAttribute('disabled');

            if (Array.from(this.sellingPlanInputs).filter(input => input.checked)[0].value !== '')
              this.productElement.dataset.purchaseOption = 'Subscribe';
          } else {
            !this.productPlanInput?.hasAttribute('disabled') && this.productPlanInput?.setAttribute('disabled', '');

            if (Array.from(this.sellingPlanInputs).filter(input => input.checked)[0].value === '')
              this.productElement.dataset.purchaseOption = '';
          }
        })
      }
    }
  )
}